export default __webpack_public_path__ + "static/media/telew_top.1ba144f5.jpg";